import { makeStyles } from "@material-ui/core";

export default function SectionCss() {
    return makeStyles((theme) => ({
        root: {
            flexGrow: 1,
        },
        paper: {
            padding: theme.spacing(2),
            color: theme.palette.text.secondary,
        },
        boxForm: {
            padding: "20px",
        },
        cardFile: {
            marginTop: 20,
            marginBottom: 20,
            width: "100%",
        },
    }));
}
